var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-nowrap"},[[_c('router-link',{class:_vm.classList,attrs:{"to":{'name': _vm.detailPath, 'params': {'id': _vm.prescriptionId}}}},[_vm._v(_vm._s(_vm.statusId === 998? 'Pay Now': 'View Prescription'))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }